export default "<input #inputBox class=\"input-box\" type=\"text\" placeholder=\"{{placeholder}}\" (keyup)=\"onChangeEvent(inputBox.value)\">\n"